import { ExtendedConfigData } from "@/hooks/useConfig/types";
import { ChannelData } from "@/pages/flighting/types/common";
import { ChartToggle } from "@/pages/flighting/types/common";
import { BarChartTooltip } from "@/pages/flighting/components/Chart/Tooltip/BarChartTooltip";
import { LineChartTooltip } from "@/pages/flighting/components/Chart/Tooltip/LineChartTooltip";

interface TooltipResolverProps {
  date: string;
  rollingROI: number | null | undefined;
  channels: ChannelData[];
  totalSpend: number;
  totalRevenue: number;
  toggles: ChartToggle[];
  hasROIData: boolean;
  config: ExtendedConfigData;
}

export const TooltipResolver: React.FC<TooltipResolverProps> = ({
  date,
  rollingROI,
  channels,
  totalSpend,
  totalRevenue,
  toggles,
  hasROIData,
  config,
}) => {
  const shouldShowRevenue = toggles.includes(ChartToggle.REVENUE);
  const shouldShowSpend = toggles.includes(ChartToggle.SPEND);
  const shouldShowROIData = toggles.includes(ChartToggle.ROI) && hasROIData;
  const allTogglesSelected = shouldShowRevenue && shouldShowSpend && shouldShowROIData;

  // Show line tooltip when:
  // 1. Spend toggle is not selected (only revenue/ROI lines), OR
  // 2. All toggles are selected AND ROI data exists (spend is shown as a line)
  const shouldShowLineTooltip = !shouldShowSpend || allTogglesSelected;

  if (shouldShowLineTooltip) {
    return (
      <LineChartTooltip
        date={date}
        rollingROI={rollingROI}
        totalRevenue={totalRevenue}
        totalSpend={totalSpend}
        config={config}
      />
    );
  }

  return (
    <BarChartTooltip
      date={date}
      rollingROI={rollingROI}
      channels={channels}
      totalSpend={totalSpend}
      totalRevenue={totalRevenue}
      config={config}
    />
  );
};

export default TooltipResolver;
